module.exports = __webpack_public_path__ + "img/second_ch.e71b741e.jpg";